// ACTION TYPE
export const actionType = {
  FETCH_INIT: 'fetchList/FETCH_INIT',
  FETCH_SUCCESS: 'fetchList/FETCH_SUCCESS',
  FETCH_FAILURE: 'fetchList/LOGOUT'
}

// REDUCER
export const fetchListReducer = (state, action) => {
  switch (action.type) {
    case actionType.FETCH_INIT:
      return {
        ...state,
        isLoading: true,
        isError: false
      }
    case actionType.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        dataList: action.payload,
      }
    case actionType.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: false,
      }
    default:
      throw new Error('Unknown action fetch list type')
  }
}